module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Start by creating a section.","subtitle":"Create a section to view the data."},"it":{"title":"Inizia creando una Sezione di monitoraggio","subtitle":"Configura almeno Sezione di monitoraggio per poter visualizzare il grafico."}}')
  delete Component.options._Ctor
}
